/** @jsx jsx */

import { isEmpty } from 'lodash';
import type { ReactNode } from 'react';

import { jsx } from '@emotion/core';
import { Grid, Margin, Spinner, Text } from '@zapier/design-system';

import Tab from '../Tab';

type Props = {
  children: ReactNode;
  isLoading: boolean;
  onClickTestAgain: () => void;
};

function BundleConsoleHttpBase({
  children,
  onClickTestAgain,
  isLoading,
}: Props) {
  return (
    <Tab onClickTestAgain={onClickTestAgain}>
      <Margin margin="15px 10px">
        {isLoading ? (
          <Grid alignItems="center" columns="20px auto" gap={10}>
            <Spinner />
            <Text>Fetching logs...</Text>
          </Grid>
        ) : isEmpty(children) ? (
          <Text>No logs to show. Please refresh logs again later.</Text>
        ) : (
          <div>{children}</div>
        )}
      </Margin>
    </Tab>
  );
}

BundleConsoleHttpBase.defaultProps = {
  children: null,
  isLoading: false,
  logs: [],
};

export default BundleConsoleHttpBase;
